// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ColumnsContainer, Row, Col } from "@components";
import type { Rows } from "@components/columns-container/types";
import { secondsToHours } from "@utils/time";
type Props = $Exact<{
  data: Object,
  ...PropsFromLocalize,
}>;

export class RtwComplianceView extends React.Component<Props> {
  get data(): Array<Rows> {
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("EXPIRY_PERIOD"),
                secondsToHours(this.props.data.expiryPeriodInSeconds),
              ],
              [
                this.props.t("LATE_REASON_CAPTURE"),
                this.props.data.lateReasonCapture
                  ? this.props.t("CAPTURE_LATE_REAS")
                  : this.props.t("DO_NOT_CAPTURE"),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("REMINDER_TIME"),
                secondsToHours(this.props.data.reminderTimeInSeconds),
              ],
              [this.props.t("REMINDER_TYPE"), this.props.t(this.props.data.reminderType)],
            ],
          },
          {
            data: [
              [
                this.props.t("COPY_IN_MANAGERS_MANAGER"),
                this.props.data.copyInManagersManager ? this.props.t("YES") : this.props.t("NO"),
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(RtwComplianceView);
